import {Component, Input, OnChanges, Output} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {DropdownsBase} from '../dropdowns.base';
import {Requests, RequestType} from '../../../../../shared/model/request.model';
import {RequestDialogComponent} from '../../../../../shared/components/request-dialog/request-dialog.component';
import {MessageService} from '../../../../../shared/components/message.service';
import {CiOrderedMultiselectComponent} from '../../../../../../profiler-theme';

@Component({
  selector: 'app-main-focus-dropdown',
  standalone: true,
  imports: [
    TranslatePipe,
    RequestDialogComponent,
    CiOrderedMultiselectComponent,
  ],
  templateUrl: './main-focus-dropdown.component.html',
})
export class MainFocusDropdownComponent
  extends DropdownsBase<Requests>
  implements OnChanges {
  @Input() availableMainFocuses: Requests[] = [];
  @Input() selectedMainFocuses: string[] = [];
  @Input() required = false;
  @Input() invalid = false;
  @Input() errorText: string | null = null;

  @Output() mainFocusesChange = this.change;

  override readonly maxItems = 5;
  protected get RequestType() { return RequestType; }
  showModal = false;

  constructor(
    translate: TranslateService,
    liveAnnouncer: LiveAnnouncer,
    messageService: MessageService,
  ) {
    super(translate, liveAnnouncer, messageService);
  }

  ngOnChanges(): void {
    this.init(this.availableMainFocuses, this.selectedMainFocuses);
  }

  onAddClick() {
    this.showModal = true;
  }
}
